import { Box, Typography, Chip, Divider, Button, Grid } from '@mui/material'
import logo from '../../assets/rounded_logo.svg'
import me from '../../assets/me.png'

export default function ProfileFrame() {
  const nextMonthFirstDay = () => {
    const d = new Date()
    const year = d.getMonth() === 11 ? d.getFullYear() + 1 : d.getFullYear()
    const month = (d.getMonth() + 1) % 12 // next month
    const first = new Date(year, month, 1)
    return first.toLocaleDateString('en-US', { month: 'long', day: 'numeric' })
  }
  return (
    <Box sx={{
      position: 'relative',
      width: 280,
      height: 560,
      bgcolor: '#000',
      borderRadius: 6,
      p: 1,
      boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
    }}>
      <Box sx={{
        width: '100%',
        height: '100%',
        bgcolor: 'white',
        borderRadius: 5,
        overflow: 'hidden',
        position: 'relative'
      }}>
        {/* Status Bar */}
        <Box sx={{
          height: 44,
          bgcolor: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          px: 2,
          fontSize: '0.875rem',
          fontWeight: 600
        }}>
          <Box component="img" src={logo} alt="HeyyProperty" sx={{ height: 40, width: 'auto', maxWidth: '60px', mt: '5px' }} />
        </Box>
        {/* Header with avatar, role, company */}
        <Box sx={{ display: 'flex', alignItems: 'center', px: 2, pt: 1 }}>
          <Box component="img" src={me} alt="Profile" sx={{ width: 44, height: 44, borderRadius: '50%', objectFit: 'cover', mr: 1.25 }} />
          <Box>
            <Typography variant="caption" color="grey.600" sx={{ display: 'block' }}>
              Engineer
            </Typography>
            <Typography variant="caption" color="grey.600" sx={{ display: 'block', mt: 0.25 }}>
              Heyy Property
            </Typography>
          </Box>
        </Box>
        {/* About Me */}
        <Box sx={{ p: 2, pb: 0 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>About Me</Typography>
          <Typography variant="body2" color="grey.700" sx={{ lineHeight: 1.5 }}>
            Hi there! I am looking for a pet friendly home ...
          </Typography>
        </Box>

        {/* Rental Preferences Card */}
        <Box sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>Rental Preferences</Typography>

          <Divider sx={{ mb: 1.25 }} />
          <Typography variant="caption" color="grey.600">Neighborhoods</Typography>
          <Box sx={{ mt: 0.75, display: 'flex', gap: 0.75, flexWrap: 'wrap', mb: 1.5 }}>
            <Chip label="Fells Point" size="small" variant="outlined" />
            <Chip label="Canton" size="small" variant="outlined" />
          </Box>
          {/* First row: Looking for, Move-in Date */}
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={6}>
              <Typography variant="caption" color="grey.600">Looking for</Typography>
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>4 bed • 3 bath</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="caption" color="grey.600">Move-in Date</Typography>
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>{nextMonthFirstDay()}</Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ mb: 0.5 }}>
            <Grid item xs={6}>
              <Typography variant="caption" color="grey.600">Dogs</Typography>
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>1</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="caption" color="grey.600">Cats</Typography>
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>1</Typography>
            </Grid>
          </Grid>
          <Typography variant="caption" color="grey.600">Home must be pet friendly</Typography>
        </Box>

        {/* Bottom CTA */}
        <Box sx={{ position: 'absolute', bottom: 14, left: 12, right: 12, display: 'flex', justifyContent: 'center' }}>
          <Button
            variant="contained"
            fullWidth
            sx={{
              bgcolor: 'black', color: 'white', textTransform: 'none', fontWeight: 700,
              borderRadius: 9999,
              py: 1.2,
              '&:hover': { bgcolor: 'grey.900' }
            }}
          >
            Request Tour w/ Me
          </Button>
        </Box>
      </Box>
    </Box>
  )
}


